import styled from 'styled-components';

export const HomeContainer = styled.div`
  max-width: 100vw;
`;
